import { Picture } from './types';

import wave4 from '../assets/waves/wickedbackground-4.svg';
import wave5 from '../assets/waves/wickedbackground-5.svg';
import wave6 from '../assets/waves/wickedbackground-6.svg';
import wave7 from '../assets/waves/wickedbackground-7.svg';
import wave8 from '../assets/waves/wickedbackground-8.svg';
import wave9 from '../assets/waves/wickedbackground-9.svg';
import wave10 from '../assets/waves/wickedbackground-10.svg';
import wave11 from '../assets/waves/wickedbackground-11.svg';
import wave12 from '../assets/waves/wickedbackground-12.svg';
import wave13 from '../assets/waves/wickedbackground-13.svg';
// import wave14 from '../assets/waves/wickedbackground-14.svg';

export const DEFAULT_PICTURE: Picture = {
  credit: { title: '', url: '' },
  title: 'Turtle followed by silver fish',
  url: `${
    process.env.APP_PLATFORM === 'extension' ? '../' : ''
  }img/background/fallback_ocean.webp`,
};

export const WAVES = [wave4, wave5, wave6, wave7, wave8, wave9, wave10, wave11, wave12, wave13]
  .map((url, index) => ({ url, id: index }));